import i18n from '@/plugins/i18n';
import { CmsMenuItem } from '@/modules/cms/menus';

const { t } = i18n.global;

const getProductCardLabel = (product: CmsMenuItem) => {
  const defaultProductCardLabelTransKey = 'thumbnail_label';

  // display a translated label message set in CMS menu for products
  // otherwise display a default string regardless of what language is active
  return product.customData?.label?.value === defaultProductCardLabelTransKey
    ? t(defaultProductCardLabelTransKey)
    : product.customData?.label?.value;
};
export {
  getProductCardLabel,
};
